<template>
  <div ref="dropdownButtonGroup" class="btn-group">
    <button ref="dropdownButton" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <slot></slot>
    </button>
    <div ref="dropdownMenu" class="dropdown-menu" style="max-width: 400px;">
      <div class="bs3-padding">
        <div class="input-group">
          <span class="input-group-addon">
            <input type="radio" v-model="action" value="COPY" aria-label="Copy"> Copy
          </span>
          <span class="input-group-addon">
            <input type="radio" v-model="action" value="DISTRIBUTE" aria-label="Distribute"> Distribute
          </span>
          <input ref="measure" v-model="measure" type="text"
                 class="form-control" aria-label="Measure" placeholder="0.00$">
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" @click="apply">Apply</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "MediaPlanTargetMeasuresMatrixAction",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pTimelineInfo: Object,
    pDimensionInfo: Object
  },
  data: function() {
    return {
      measure: null,
      action: 'COPY'
    }
  },
  methods:{
    reset: function() {
      this.measure = null;
      this.action= 'COPY';
    },
    apply: function() {
      this.$emit('media-plan-target-measures-matrix-action', this.action, this.measure, this.pDimensionInfo, this.pTimelineInfo);
      $(this.$refs.dropdownButton).dropdown('toggle');
    }
  },
  mounted: function () {
    let _component = this;
    $(_component.$refs.dropdownButtonGroup).on('show.bs.dropdown', function () {
      _component.$emit('media-plan-target-measures-matrix-action-open');
     _component.reset();
    });

    $(_component.$refs.dropdownButtonGroup).on('shown.bs.dropdown', function () {
      _component.$refs.measure.focus();
    });

    $(_component.$refs.dropdownMenu).on("click.bs.dropdown", function (e) {
      e.stopPropagation();
    });

    $(_component.$refs.dropdownButtonGroup).on('hide.bs.dropdown', function () {
      _component.$emit('media-plan-target-measures-matrix-action-close');
    });
  }
}
</script>

<style scoped>

</style>